import type { Namespace as I18nextNamespace, ParseKeys } from 'i18next';
import { LOCALE_CONFIG } from '@/consts/common';
import i18n from '@/lib/i18n/i18n';

type AllNamespaces = (typeof LOCALE_CONFIG.NAMESPACES)[number];
type Namespace = Extract<I18nextNamespace, AllNamespaces>;

const FALLBACK_DEFAULT_CODE = 'service.unknown.internal';

const fallbackText = () => i18n.t(FALLBACK_DEFAULT_CODE, {
  ns: 'errors',
  keySeparator: false,
});

function getErrorCodes(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  return FALLBACK_DEFAULT_CODE;
}

// All valid keys for a specific namespace Ns from JSON resources
export type KeysFori18nNs<Ns extends Namespace> = ParseKeys<Ns> & string;

export function getI18nMessage<Ns extends Namespace>(
  ns: Ns,
  key: KeysFori18nNs<Ns>,
  defaultValue: string,
  values?: Record<string, unknown>,
): string {
  return i18n.t(key, {
    ns,
    defaultValue,
    ...values,
  }) as string;
}

export function getErrorMessage(error: unknown): string {
  const errorCode = getErrorCodes(error);
  return getI18nMessage('errors', errorCode as KeysFori18nNs<'errors'>, fallbackText());
}
